<template>
<div :class="['amf-info-row']">
    <div :class="['container-fluid', 'top-border']">
        <div class="row py-2">
            <div class="title col-2">
                <span>{{label}}</span>
            </div>

            <div class="text col-10">
                {{summary}}
                <slot></slot>
            </div>
        </div>
    </div>    
</div>
</template>

<script>
export default {
    props: {
        label: { type: String, required: true },
        summary: { type: String, required: true },
    }
}
</script>

<style scoped lang="scss">
.amf-info-row { 

    .title {
        font-weight: 500;
        text-align: right;
    }


    // .top-border {
    //     border-top: 1px darkgray solid;
    // }

    .explanation {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        font-size: 80%;
        color: lighten(black, 50);
    }
}

</style>



// WEBPACK FOOTER //
// src/framework/primitives/AmfInfoRow.vue